import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, vModelText as _vModelText, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5d448ab9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "invite-recipient" }
const _hoisted_2 = {
  key: 0,
  class: "selected-contact"
}
const _hoisted_3 = { class: "address" }

import { computed, ref } from 'vue'
import { useManageStore } from '@/manage/ManageStores'
import AutoCompleteInput from "@/util/AutoCompleteInput.vue"
import ContactSearchItem from "@/manage/contacts/ContactSearchItem.vue"
import { Contact, getContactDisplayName } from '@/manage/contacts/ContactProviders'
import { useContactStore } from '@/manage/contacts/ContactStore'
import { AddressUtil } from '@/util/AddressUtil'

interface ContactResult {
  value: string
  contact: Contact
  score: number
}


export default /*#__PURE__*/_defineComponent({
  __name: 'FamilyGroupInviteRecipient',
  props: {
    profileId: {}
  },
  setup(__props: any, { expose: __expose }) {

const props = __props;



__expose({
  focus,
  validate,
})

const manageStore = useManageStore()
const contactStore = useContactStore()

const useContactsRef = computed(() => !!contactStore.contactProviderId)
const addressRef = computed({
  get: () => manageStore.inviteAddresses.get(props.profileId ?? ''),
  set: value => manageStore.inviteAddresses.set(props.profileId!, value)
})
const selectedContactRef = ref<Contact>()

const contactSearchInputRef = ref<InstanceType<typeof AutoCompleteInput>>()
const addressInputRef = ref<HTMLInputElement>()

function searchContacts(query: string) {
  //console.log(`Searching contacts for ${searchTextRef.value}`)
  
  // copy to address in case they type an email directly, not a search term
  addressRef.value = query

  const rx = new RegExp(query, 'i')
  const prx = new RegExp('^' + query, 'i')

  const results = [] as ContactResult[]
  for (const c of contactStore.contacts.values()) {
    if (c.emailAddresses.length) {
      let score = 0
      for (const n of c.names) {
        if (score < 2) {
          score = Math.max(score,
            getMatchScore(n.givenName, rx, prx), 
            getMatchScore(n.familyName, rx, prx), 
            getMatchScore(n.middleName, rx, prx), 
            getMatchScore(n.displayName, rx, prx)
          )
        }
      }
      if (score < 2) {
        score = Math.max(score, ...c.emailAddresses.map(e => getMatchScore(e.value, rx, prx)))
      }
      if (score > 0) {
        results.push({ value: c.emailAddresses[0].value, contact: c, score })
      }
    }
  }
  results.sort((a, b) => b.score - a.score)
  return results
}

function getMatchScore(value: string | undefined, rx: RegExp, prx: RegExp) {
  return !value ? 0 : prx.test(value) ? 2 : rx.test(value) ? 1 : 0
}

function contactSelected(item: ContactResult) {
  addressRef.value = item.value
  selectedContactRef.value = item.contact
  console.log(`Contact selected: ${item.value}`)
}

function removeContact() {
  addressRef.value = ''
  selectedContactRef.value = undefined
}

function focus() {
  if (useContactsRef.value) {
    contactSearchInputRef.value?.focus()
  }
  else {
    addressInputRef.value?.focus()
  }
}

function validate() {
  return AddressUtil.isValidEmail(addressRef.value)
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (useContactsRef.value && selectedContactRef.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", null, [
            _createTextVNode(_toDisplayString(_unref(getContactDisplayName)(selectedContactRef.value) ?? addressRef.value) + " ", 1),
            _createElementVNode("span", _hoisted_3, "(" + _toDisplayString(addressRef.value) + ")", 1)
          ]),
          _createElementVNode("button", {
            type: "button",
            class: "btn-close",
            onClick: removeContact
          })
        ]))
      : (useContactsRef.value)
        ? (_openBlock(), _createBlock(AutoCompleteInput, {
            key: 1,
            ref_key: "contactSearchInputRef",
            ref: contactSearchInputRef,
            placeholder: "contact name or address",
            search: searchContacts,
            "item-component": ContactSearchItem,
            onResultSelected: contactSelected
          }, null, 512))
        : _withDirectives((_openBlock(), _createElementBlock("input", {
            key: 2,
            type: "email",
            ref_key: "addressInputRef",
            ref: addressInputRef,
            class: "form-control",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((addressRef).value = $event)),
            placeholder: "email address"
          }, null, 512)), [
            [_vModelText, addressRef.value]
          ])
  ]))
}
}

})